import { render, staticRenderFns } from "./ButtonField.vue?vue&type=template&id=bb1fa458&scoped=true&"
import script from "./ButtonField.vue?vue&type=script&lang=js&"
export * from "./ButtonField.vue?vue&type=script&lang=js&"
import style0 from "./ButtonField.vue?vue&type=style&index=0&id=bb1fa458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1fa458",
  null
  
)

export default component.exports